// removed by extract-text-webpack-plugin
module.exports = {"root":"_37h3AHJvnVC-1BDgSDDzYV_0","dot":"_3Ey59EQ-UV01eBuCw8CjUe_0","dotsContainer":"ItSi-oElHeZRaSF0i7GdO_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-042c153b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BackgroundAnimation.vue
// module id = OIFw
// module chunks = 13